import {
  setUserDetails,
  setUserDetailsError,
  setUserDetailsLoading
} from '../redux/slices/login';
import { setItemInStorage } from '../storage/Storage';
import { toast } from 'react-toastify';
import { errorMessage } from '../lib/helper';
import { STATUS_200, STATUS_300 } from '../data/constants';
import ApiConfig from '../config/ApiConfig';
import axios from 'axios';
import { getUserDetailService } from './userService';

const mockApi = async (endpoint, payload) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: {
          status: 200,
          access_token: 'tlkjasdf',
          data: {
            email: "test@yopmail.com",
            first_name: "Test",
            last_name: "User",
            phone_number: 1234567890,
            profile_pic: "",
            status: "1",
          },
          message: 'Successfully Login!!'
        }
      })
    }, 2000)
  })
}

export const loginUser = (payload, login) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setUserDetailsLoading(true));
        const resp = await axios.post(ApiConfig.login, payload);
        if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
          setItemInStorage('token', resp?.data?.data?.token);
          setItemInStorage('ref_token', resp?.data?.data?.refreshAuth);
          const response = await getUserDetailService();
          if (response?.data) {
            const user = response?.data;
            login(user);
            dispatch(setUserDetails(user));
            dispatch(setUserDetailsLoading(false));
            toast.success(resp.data.message, {
              autoClose: 2500,
            });
            return true
          } else {
            toast.error(response?.data?.data || resp?.data?.data);
          }
        } else {
          throw resp
        }
      } catch (e) {
        dispatch(
          setUserDetailsError({
            isError: true,
            message: errorMessage(e),
          }),
        );
        dispatch(setUserDetailsLoading(false));
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        return false
      }
    };
  }
};

